import { render, staticRenderFns } from "./MainPages.vue?vue&type=template&id=87b4142e&"
import script from "./MainPages.vue?vue&type=script&lang=js&"
export * from "./MainPages.vue?vue&type=script&lang=js&"
import style0 from "./MainPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports